import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GerinusService } from '../lib/gerinus.service';

@Injectable()
export class RequestAttachmentService extends GerinusService {
    constructor(public http: HttpClient) {
        super(http);
        this.entityName = 'solicitacao_anexo';
        this.idField = 'SOLA_CodigoSolicitacaoAnexo';
        this.model = 'SolicitacaoAnexoModel';
    }
}
